/*
 * @Author: 王枫叶
 * @Date: 2020-10-21 14:11:47
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-12-17 19:43:50
 */
import ajax from "../utils/request";
const loufApi={ 
      /** ********************楼凤列表************************* */
  // 获取楼凤列表 
    getLouFengList(params) {
    return ajax({
      url: '/loufeng/list',
      type: 'post',
      params: params
    })
  },
  // 新增
  addLoufeng(params) {
    return ajax({
      url: '/loufeng/add',
      type: 'post',
      params: params
    })
  },
  // 修改
  updateLoufeng(params) {
    return ajax({
      url: '/loufeng/edit',
      type: 'post',
      params: params
    })
  },
  // 删除
  deleteLoufeng(params) {
    return ajax({
      url: '/loufeng/del',
      type: 'delete',
      params: params
    })
  },
  // 取消置顶
  cancelToplf(params) {
    return ajax({
      url: '/loufeng/cancelTop',
      type: 'post',
      params: params
    })
  },
  /**************楼凤配置******************/
    // 获取楼凤列表 
    getLoufCfgList(params) {
      return ajax({
        url: '/loufeng/getConfig',
        type: 'get',
        params: params
      })
    },
    // 修改
    editLoufCfg(params) {
      return ajax({
        url: '/loufeng/setConfig',
        type: 'post',
        params: params
      })
    },

      /**************举报信息列表******************/
    // 获取举报信息
    getFeedbList(params) {
      return ajax({
        url: '/loufeng/getFeedback',
        type: 'post',
        params: params
      })
    },
    // 修改举报信息
    editFeedb (params) {
      return ajax({
        url: '/loufeng/processFeedback',
        type: 'post',
        params: params
      })
    },

        /** ********************楼凤广告配置************************* */
  // 获取列表 
  getLfAdList(params) {
    return ajax({
      url: '/loufengad/list',
      type: 'post',
      params: params
    })
  },
  // 新增
  addLfAd(params) {
    return ajax({
      url: '/loufengad/add',
      type: 'post',
      params: params
    })
  },
  // 修改
  updateLfAd(params) {
    return ajax({
      url: '/loufengad/edit',
      type: 'post',
      params: params
    })
  },
  // 删除
  deleteLfAd(params) {
    return ajax({
      url: '/loufengad/del',
      type: 'post',
      params: params
    })
  },
}

  export default loufApi;